// @flow
import * as React from 'react';
import classNames from 'classnames';
import Box from '@stripe-internal/sail/Box';
import SailFlagIcon, {FLAG_COUNTRY_CODES} from '@stripe-internal/sail/FlagIcon';
import './FlagIcon.scss';

export type FlagCountryCode = $Keys<typeof FLAG_COUNTRY_CODES>;
type FlagIconProps = {|
  country: FlagCountryCode,
  title?: string,
  label?: string,
  inline?: boolean,
|};

export const FlagIcon = ({
  country,
  title,
  label,
  inline = true,
}: FlagIconProps) => {
  return (
    <Box
      className={classNames('FlagIcon', {inline})}
      flex={{alignItems: 'center'}}
    >
      <SailFlagIcon countryCode={country} title={title} size={16} />
      {label && <span style={{marginLeft: '4px'}}>{label}</span>}
    </Box>
  );
};
